import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { DeleteAntibiotic } from './DeleteAntibiotic';
import { FormAntibiotic } from './FormAntibiotic';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalAntibiotic = (props) => {

    const {
        modal, modalTitle, toggle, method,
        validaciones,
        antibiotic,
        handleInputChange, loading,
        saveCreate, saveUpdate, closeDialog, aware
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icon-notepad f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando antibiotico..." : "Crear antibiotico"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            {
                                loading ? "Actualizando antibiotico..." : "Actualizar antibiotico"
                            }
                        </Button>
                    }



                    <Button
                        size="sm"
                        color='danger'
                        type="button" onClick={closeDialog}>
                        Cancelar
                    </Button>

                </>
            }
        >

            {
                method === "create"
                    ? <FormAntibiotic
                        button={"Crear antibiotico"}
                        {...{ closeDialog, loading, handleInputChange, aware, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormAntibiotic
                            button={"Actualizar antibiotico"}
                            {...{ closeDialog, loading, handleInputChange, validaciones, aware, methodAction: saveUpdate, antibiotic, }} />
                        :
                        null
            }
        </Dialog>
    )
}
